import React, { forwardRef } from 'react'
import styled from 'styled-components'
import { grid, typography } from 'styled-system'

import { StyledLink, StyledExternalLink } from './StyledLink'

const GridStyledLink = styled(StyledLink).attrs(props => ({
  alignItems: props.alignItems || 'center',
  justifyContent: props.justifyContent || 'center',
  display: 'inline-grid',
  gridTemplateColumns: props.gridTemplateColumns || '1fr',
  gridTemplateRows: props.gridTemplateRows || '1fr',
  textWrap: props.textWrap || 'pretty',
  ...props
}))(
  {
    span: { textAlign: 'center' }
  },
  grid,
  typography
)

const GridExternalStyledLink = styled(StyledExternalLink)(
  {
    display: 'inline-grid',
    gridTemplateColumns: '1fr',
    gridTemplateRows: '1fr',
    placeItems: 'center',
    textWrap: 'pretty',
    span: { textAlign: 'center' }
  },
  grid,
  typography
)

/**
 * This is the main link that is used throughout the website. It consists of a pill-shaped link with an optional arrow
 */
export const BonoboLink = forwardRef(
  (
    {
      prependArrow = false,
      appendArrow = false,
      to,
      external,
      children,
      ...props
    },
    ref
  ) => {
    let linkProps = { to }
    if (external) {
      linkProps = {
        as: 'a',
        href: to,
        target: '_blank',
        rel: 'noopener noreferrer'
      }
    }

    const LinkComponent = external ? GridExternalStyledLink : GridStyledLink

    return (
      <LinkComponent {...props} {...linkProps} gridGap={[2, 2, 2, 0]} ref={ref}>
        {prependArrow ? '→ ' : null}
        {children}
        {appendArrow ? ' →' : null}
      </LinkComponent>
    )
  }
)
